import { motion } from "framer-motion";
import {
 data
} from "./data.js";
import BoxLayout from "@components/BoxLayout/BoxLayout.jsx";

export const WhyChooseCustomWebAppDevelopment = () => {
  return (
    <>
      <section className="container space-y-14 ">
        <div className="space-y-5 mx-auto md:w-11/12 lg:w-10/12 xl:w-8/12   ">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
         className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] text-center  font-bold text-dark font-butler"
          >
            Why Choose Custom Web App Development{" "} 
          </motion.h2>
         
        </div>

        <div className="flex flex-wrap  gap-x-6 gap-y-8 justify-center">
          {data.map((list, index) => {
            return (
              <BoxLayout
                key={index}
                index={index}
                icon={list.icon}
                heading={list.heading}
                text={list.text}
                colorScheme={["#erer", "#df"]}
              />
            );
          })}
        </div>
      </section>
     
     
    </>
  );
};
